import http from 'apis/config/http-service';
import type { AxiosResponse } from 'axios';
import { useCallback } from 'react';

const endpoint = 'api/v1/cms/restaurant-suppliers/available-restaurants';

type TOption = {
  value: number;
  label: string;
};

interface AvailableRestaurantDto {
  id: number;
  name: string;
}

export function useGetAvailableRestaurantsApi() {
  // Curried by supplierId (dependent dropdown). Returns the (inputValue, callback)
  // function ChakraAsyncSelect expects.
  const loadOptions = useCallback(
    (supplierId: number) => (inputValue: string, callback: (options: TOption[]) => void) => {
      if (inputValue.length < 2) {
        callback([]);
        return;
      }

      http
        .get(endpoint, {
          params: {
            supplierId,
            name: inputValue,
            page: 1,
            limit: 20,
          },
        })
        .then((res: AxiosResponse) => {
          const options: TOption[] = (res?.data?.data || []).map((item: AvailableRestaurantDto) => ({
            value: item.id,
            label: item.name,
          }));
          callback(options);
        })
        .catch(() => callback([]));
    },
    []
  );

  return { loadOptions };
}
